import React, { useState } from 'react';
import './AppFooter.scss';
import { appInfo } from '../../../app-info';
import foresLogo from '../../../assets/fores-logo.png';
import { Popup } from 'devextreme-react';


export const AppFooter = ({ ...rest }) => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupContent, setPopupContent] = useState("")
  const [popupTitle, setPopupTitle] = useState("")

  function clickHandle(type) {
    if (type == 1) {
      setPopupTitle("Impressum")
      setPopupContent("https://fores.de/impressum.html")
    } else if (type == 2) {
      setPopupTitle("Datenschutzbestimmungen")
      setPopupContent("https://fores.de/datenschutz.html")
    } else if (type == 3) {
      setPopupTitle("Allgemeine Geschäftsbedingungen")
      setPopupContent("https://fores.de/agb.html")
    } else if (type == 4) {
      setPopupTitle("Kontakt")
      setPopupContent("https://fores.de/index.html#contact")
    } else if (type == 5) {
      setPopupTitle("Über Uns")
      setPopupContent("https://fores.de/index.html#about")
    }
    setPopupVisible(true)
  }

  return (
    <div>
      <div className="app-footer py-1 px-2 shadow-[0px_-2px_5px_rgba(0,0,0,0.1)] bg-[var(--base-bg)] text-[var(--base-text-color-alpha)]">
        <div className='flex justify-between  items-center'>
          {/* <div className='flex gap-3 '>
            <p></p>
            <span className='cursor-pointer active:scale-90 transition text-xs' onClick={() => clickHandle(1)}>Impressum</span>
            <p className='text-xs'>|</p>
            <span className='cursor-pointer active:scale-90 transition text-xs' onClick={() => clickHandle(2)}>Datenschutz</span>
            <p className='text-xs'>|</p>
            <span className='cursor-pointer active:scale-90 transition text-xs' onClick={() => clickHandle(3)}>AGB</span>
            <p className='text-xs'>|</p>
            <span className='cursor-pointer active:scale-90 transition text-xs' onClick={() => clickHandle(4)}>Kontakt</span>
            <p className='text-xs'>|</p>
            <span className='cursor-pointer active:scale-90 transition text-xs' onClick={() => clickHandle(5)}>Über Uns</span>
          </div> */}
          <div className='flex items-center'>
          <span className='mx-1 text-xs'></span>
            <span className='cursor-pointer active:scale-90 transition text-xxs' onClick={() => clickHandle(1)}>Impressum</span>
            <span className='mx-1 text-xs'>|</span>
            <span className='cursor-pointer active:scale-90 transition text-xxs' onClick={() => clickHandle(2)}>Datenschutz</span>
            <span className='mx-1 text-xs'>|</span>
            <span className='cursor-pointer active:scale-90 transition text-xxs' onClick={() => clickHandle(3)}>AGB</span>
            <span className='mx-1 text-xs'>|</span>
            <span className='cursor-pointer active:scale-90 transition text-xxs' onClick={() => clickHandle(4)}>Kontakt</span>
            <span className='mx-1 text-xs'>|</span>
            <span className='cursor-pointer active:scale-90 transition text-xxs' onClick={() => clickHandle(5)}>Über Uns</span>
            <span className='mx-1 text-xs'></span>
          </div>

          <div className="flex items-center gap-4">
            <div className="hidden text-xxs md:block">
              {'Version '} {appInfo().version}
            </div>
            <div className="hidden md:block">
              <a
                rel="noreferrer"
                target="_blank"
                href="https://fores.de/"
                className="bg-white p-0.5 rounded-sm flex items-center"
              >
                <img src={foresLogo} height={15} width={45} alt="Fores Logo" />
              </a>
            </div>
            <p></p>
          </div>
        </div>

      </div>
      <Popup
        height={"75%"}
        width={"75%"}
        visible={popupVisible}
        onHiding={() => setPopupVisible(false)}
        showCloseButton={true}
        title={popupTitle}
        hideOnOutsideClick
        contentRender={() => <div>
          <iframe
            src={popupContent}
            className="h-[60vh] w-full"
          />
        </div>} />
    </div>
  )

};
